export function getDefaultFrom() {
  // Prefer EMAIL_FROM; fallback to CONTACT_PUBLIC_EMAIL; final default is the gmail
  const env = process.env || {};
  return (
    env.REACT_APP_EMAIL_FROM ||
    env.REACT_APP_CONTACT_PUBLIC_EMAIL ||
    "support@buildbright.app"
  );
}

export function getPublicEmail() {
  // Public-facing email for UI links
  const env = process.env || {};
  return (
    env.REACT_APP_CONTACT_PUBLIC_EMAIL ||
    env.REACT_APP_LEGAL_CONTACT_EMAIL ||
    "support@buildbright.app"
  );
}
